import React from "react";

const FormTypeContext = React.createContext("add");

export default FormTypeContext;
